module.exports = __webpack_public_path__ + "static/media/home-right.c46af044.png";